import { styled } from 'parkdepot-shared/theme'

export const ArrowIcon = styled<'i', { $left?: boolean }>('i', ({ $theme, $left }) => ({
    cursor: 'pointer',
    backgroundColor: '#F6F6F6',
    color: '#000',
    borderRadius: '50%',
    fontSize: '14px',
    padding: '7px',
    opacity: '0.8',
    ':hover': {
        opacity: 1
    },
    transition: 'opacity .2s ease-in-out',
    ...($left
        ? {
              marginLeft: '4px'
          }
        : {
              marginRight: '4px'
          })
}))

export const Container = styled('div', () => ({
    height: '22rem'
}))

export const Image = styled('img', ({ $theme }) => ({
    width: '100%',
    maxHeight: '22rem !important',
    objectFit: 'cover',

    [$theme.mediaQuery.large]: {
        maxHeight: 'none',
        marginBottom: '-2.5px'
    }
}))
